module.exports = {
      id: "marker-usage",
      viewBox: "0 0 27 36",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#marker-usage",
      toString: function () {
        return this.url;
      }
    }